export const BridgeParamsAbi = {
  name: 'BridgeParams',
  type: 'tuple',
  components: [
    {
      internalType: 'Currency',
      name: 'currency',
      type: 'address',
    },
    {
      internalType: 'address',
      name: 'sgRouter',
      type: 'address',
    },
    {
      internalType: 'address',
      name: 'refundAddress',
      type: 'address',
    },
    {
      internalType: 'uint256',
      name: 'srcPoolId',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'dstPoolId',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'homeGas',
      type: 'uint256',
    },
    {
      internalType: 'bytes',
      name: 'packedRecipient',
      type: 'bytes',
    },
    {
      internalType: 'bytes',
      name: 'payload',
      type: 'bytes',
    },
    {
      internalType: 'uint16',
      name: 'dstEid',
      type: 'uint16',
    },
    {
      internalType: 'uint16',
      name: 'maxSlippageBP',
      type: 'uint16',
    },
  ],
} as const
